import React, { Fragment } from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import NativeAjax from '../../../util/NativeAjax';
import $ from 'jquery';
import { memo } from 'react';

class InternContainerComponent extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.state = {
			teamperPage: [],
			page: 0,
			data: [],
			userClicked: false,
			ourTeams: [],
			paginatedourTeams: []
		}
	}

	profileClickedFn = (elem, evt) => {
		var me = this;
		if (typeof this.props.profileClickedFn === "function") {
			let profilejsonName = elem.title.toLowerCase();
			var success = function (response) {
				me.setState({ userClicked: true });
				console.log("response === ", response)
				me.props.profileClickedFn((response));
			}

			var failure = function (err) {
				console.log("getting failure === ", err)
			}
			new NativeAjax(('../../teampage/images/profiles/' + profilejsonName + '.json')).enableCORS().get(success, failure);
		}
	}

	componentDidMount() {
		var me = this;
		console.log("teampageName ", this.props.getPageValue())
		this.setState({ page: this.props.getPageValue() },
			() => {
				me.setPage()
			})
	}

	internnextPage = () => {
		var me = this;
		var teamdiv = $(".teamimgcontainer");
		teamdiv.animate({ left: '-500px', opacity: '0' }, "fast").promise().done(function () {
			teamdiv.css("left", "500px");
			teamdiv.css("opacity", "0.5");
			me.setState(state => {
				let nextPage = state.page + 1
				if (nextPage > state.data.length - 1) {
					nextPage = state.page
				}
				return {
					page: nextPage
				}
			},
				() => {
					setTimeout(function () {
						me.setPage();
					}, 100)
					teamdiv.animate({ left: '0px', opacity: '1' }, "fast")
					let teamCount = (me.state.data && me.state.data.length > 0) ? me.state.data.length : 0;
					console.log("teamCount ", teamCount, " : ", me.state.page, " : ", me.props.pageNo);
					if (typeof me.props.decrementFn === "function" && teamCount > 0) {
						if (me.state.page < (teamCount)) {
							me.props.incrementFn(teamCount);
						}
					}
				})
		})
	}

	internprevPage = () => {
		var me = this;
		var teamdiv = $(".teamimgcontainer");
		teamdiv.animate({ left: '500px', opacity: '0' }, "fast").promise().done(function () {
			teamdiv.css("left", "-500px");
			teamdiv.css("opacity", "1");
			me.setState((state) => {
				let prevPage = state.page - 1
				if (prevPage < 0) {
					prevPage = state.page
				}
				return {
					page: prevPage
				}
			},
				() => {
					let teamCount = (me.state.data && me.state.data.length > 0) ? me.state.data.length : 0;
					console.log("teamCount ", teamCount, " : ", me.state.page, " : ", me.props.pageNo);
					if (typeof me.props.decrementFn === "function" && teamCount >= 0) {
						if (me.state.page >= 0) {
							me.props.decrementFn(teamCount);
						}
					}
					setTimeout(function () {
						me.setPage();
					}, 100)
					teamdiv.animate({ left: '0px', opacity: '1' }, "fast")
				})
		})
	}

	handlePage = (index) => {
		this.setPage(index)
	}
	setPage = () => {
		const data = this.useFetch();
		this.setState({
			data: data,
		})
		const teamperPage = data[this.state.page];
		this.setState({
			teamperPage: teamperPage
		})
	}

	alttxtFn(a, b) {
		return a + ", " + b;
	}

	useFetch = () => {
		const data = this.paginate();
		this.setState({
			paginatedourTeams: data
		})
		return data
	}

	paginate = () => {
		let ourTeams = this.props.internList;
		let itemsPerPage = 15;
		if (this.isMobile() == true && this.isTab() == false) {
			itemsPerPage = 3
		} else if (this.isMobile() == true && this.isTab() == true) {
			itemsPerPage = 9
		} else {
			if (window.innerWidth == 768 || window.innerWidth == 1024) {
				itemsPerPage = 9
			} else {
				itemsPerPage = 15
			}
		}
		const numberOfPages = Math.ceil(ourTeams.length / itemsPerPage)
		const newspiltedteamPage = Array.from({ length: numberOfPages }, (_, index) => {
			const start = index * itemsPerPage
			return ourTeams.slice(start, start + itemsPerPage)
		})

		return newspiltedteamPage
	}
	showButtons = () => {
		if (this.state.paginatedourTeams.length > 1) {
			return (
				<Fragment>

					{
						(() => {
							if (this.state.page > 0) {
								return (
									<button className='prev-btn swiper-button-prev swp-prev' disabled={this.state.page === 0} onClick={this.internprevPage}>
									</button>
								)
							}
						})()
					}

					{
						(() => {
							if (this.state.page < (this.state.data.length - 1)) {
								return (
									<button className='next-btn swiper-button-next swp-next' onClick={this.internnextPage}>
									</button>
								)
							}
						})()
					}
				</Fragment>
			)
		}

	}

	showSchool = (schoolnme) => {
		return (
			<h6>{schoolnme}</h6>
		)
	}

	callforDesktop = (teamperPage) => {
		return (
			teamperPage.map((element, index) => {
				return (
					<Fragment key={index} >
						<a className="profile" onClick={this.profileClickedFn.bind(this, element)}>
							<figure>
								<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: element.picstyle }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)}></div>
								<figcaption>
									<h5>{element.name}</h5>
									{
										(element.school) ? this.showSchool(element.school) : null
									}
								</figcaption>
							</figure>
						</a>
					</Fragment >
				)
			})
		);
	}
	callforMobile = (teamperPage) => {
		console.log("Me in Mobile......")
		return (
			teamperPage.map((element, index) => {
				return (
					<Fragment key={index}>
						<a className="profile profileformobile" onClick={this.profileClickedFn.bind(this, element)}>
							<figure>
								<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: element.picstyle }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)}></div>
								<figcaption>
									<h5>{element.name}</h5>
									{
										(element.school) ? this.showSchool(element.school) : null
									}
								</figcaption>
							</figure>
						</a>
					</Fragment>
				)
			})
		);
	}
	callforIpad = (teamperPage) => {
		console.log("window.innerWidth == ", window.innerWidth + " == " + this.state.ourOrientation)
		return (
			teamperPage.map((element, index) => {
				return (
					<Fragment key={index}>
						<a className="profile profileforipad" onClick={this.profileClickedFn.bind(this, element)}>
							<figure>
								<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: element.picstyle }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)}></div>
								<figcaption>
									<h5>{element.name}</h5>
									{
										(element.school) ? this.showSchool(element.school) : null
									}
								</figcaption>
							</figure>
						</a>
					</Fragment>
				)
			})
		);
	}
	checkforDevice = (teamperPage) => {
		if (this.isMobile() == true && this.isTab() == false) {
			return this.callforMobile(teamperPage)
		} else if (this.isMobile() == true && this.isTab() == true) {
			return this.callforIpad(teamperPage)
		} else {
			return this.callforDesktop(teamperPage)
		}
	}

	renderpages = () => {
		const teamperPage = this.state.teamperPage;
		return (
			< section className="mtb product-main founder interncontainer">
				<div className="container ourteamcontainer">
					<div className="">
						<div className="col-12 row d-flex flex-center teamimgcontainer">
							{
								this.checkforDevice(teamperPage)
							}
						</div>
					</div>
					{
						this.showButtons()
					}
				</div>
			</section >
		);
	}
	render() {
		const teamperPage = this.state.teamperPage;
		if (this.state.teamperPage && this.state.teamperPage.length > 0) {
			return this.renderpages(teamperPage);
		} else {
			return this.showLoader()
		}
	}
}

export default InternContainerComponent;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/InternContainerComponent.js